import { all, put, SagaGenerator, select, takeLatest } from "typed-redux-saga";
import { Action, AnyAction } from "typescript-fsa";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { NEW_INSTANCE_IDENTIFIER } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { Commands, Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { TASK_DETAIL_ACTIVITY_ID } from "../../../processOverview/store/actions";

export const revokeEditChangesEvent = "revoke_edit_changes";

export function* cancelEditAntragSaga(): SagaGenerator<void> {
	yield* takeLatest((action: AnyAction) => {
		return (
			FormEngineActions.event.match(action) &&
			Events.eventButton.match(action.payload.engineEvent) &&
			revokeEditChangesEvent === action.payload.engineEvent.payload.name
		);
	}, handle);
}

type EventAction = Action<FormEngineActions.FormEngineEventActions>;

function* handle(action: EventAction): SagaGenerator<void> {
	const { activityId } = action.payload;

	const isDirty = yield* select(ActivitySelectors.dirty(activityId));

	if (isDirty) {
		yield* put(
			ActivityActions.create({
				activityDescriptor: {
					modal: "DirtyHandling",
					instance: NEW_INSTANCE_IDENTIFIER
				},
				initiatingActivityId: activityId
			})
		);
	} else {
		yield* all([
			put(
				FormEngineActions.command({
					activityId,
					engineEvent: Commands.setReadonly(true)
				})
			),
			put(
				FormEngineActions.command({
					activityId: TASK_DETAIL_ACTIVITY_ID,
					engineEvent: Commands.setReadonly(false)
				})
			)
		]);
	}
}
